import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.brand-marquee__top-splide' ).length > 0 && $( '.brand-marquee__bottom-splide' ).length > 0 ) {
        $( '.brand-marquee' ).each( function( index, element ) {
          const topSlider = new Splide( $( this ).find( '.brand-marquee__top-splide' )[0], {
            type: 'loop',
            gap: '8px',
            perPage: 4,
            pagination: false,
            arrows: false,
            autoScroll: {
              speed: -1,
              pauseOnHover: false,
            },
            breakpoints: {
              1024: {
                perPage: 3,
              },
              768: {
                perPage: 2,
              },
            },
          } );
          const bottomSlider = new Splide( $( this ).find( '.brand-marquee__bottom-splide' )[0], {
            type: 'loop',
            gap: '8px',
            perPage: 4,
            pagination: false,
            arrows: false,
            autoScroll: {
              speed: 1,
              pauseOnHover: false,
            },
            breakpoints: {
              1024: {
                perPage: 3,
              },
              768: {
                perPage: 2,
              },
            },
          } );
          topSlider.mount( {AutoScroll} );
          bottomSlider.mount( {AutoScroll} );
          $( this ).find( '.brand-marquee__sliders-wrapper' ).on( 'mouseover', function() {
            topSlider.Components.AutoScroll.pause();
            bottomSlider.Components.AutoScroll.pause();
          } );
          $( this ).find( '.brand-marquee__sliders-wrapper' ).on( 'mouseout', function() {
            topSlider.Components.AutoScroll.play();
            bottomSlider.Components.AutoScroll.play();
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'brand-marquee', COMPONENT );
} )( app );
